import { formatTextStyle } from "@/pages/banner/js/banner-feature";
import { bannerMap, genInitSizeInfo } from "@/pages/banner/js/banner-static";
export const banner = {
  namespaced: true,
  state: {
    bannerTextStyles: [],
    bannerBackgrounds: [],
    bannerElements: [],
    bannerData: JSON.parse(JSON.stringify(bannerMap)),
    bannerDataList: [],
    scale: 100,
    logoOptions: [],
  },
  mutations: {
    // 更新bannerData
    updateBannerData (state, map) {
      if (map.key !== undefined && map.data) {
        if (Array.isArray(map.data)) {
          map.data.splice(map.key, 1, JSON.parse(JSON.stringify(map.value)));
        } else {
          map.data[map.key] = map.value;
        }
        return;
      }
      if (map.params && map.data) {
        Object.assign(map.data, map.params);
        return;
      }
      Object.assign(state.bannerData, map);
    },
    // 构造素材和背景的列表
    setBannerMaterials (state, { elements, backgrounds }) {
      state.bannerBackgrounds = backgrounds;
      state.bannerElements = elements;
    },
    setLogoOptions (state, logoOptions) {
      state.logoOptions = logoOptions;
    },
    // 构造文字样式
    setBannerTextStyles (state, bannerTextStyleList) {
      bannerTextStyleList.forEach(item => {
        formatTextStyle(item.styles);
        // item.styles.forEach((textStyle, index) => {
        //   let arr = textStyle.textCountLimit.split("<x<");
        //   if (index) {
        //     textStyle.marginTop = textStyle.marginTop || "8";
        //   }
        //   textStyle.max = arr[1];
        //   textStyle.min = arr[0];
        //   textStyle.labelStyle = "样式1";
        //   textStyle.showLabelStyle = false;
        // });
      });
      state.bannerTextStyles = bannerTextStyleList;
    },
    // 更新bannerDataList每一项的某个属性
    updateBannerDataList (state, map) {
      const { key, dataKey, value } = map;
      state.bannerDataList.forEach(banner => {
        if (key !== undefined && dataKey) {
          if (Array.isArray(banner[dataKey])) {
            banner[dataKey].splice(key, 1, JSON.parse(JSON.stringify(value)));
            if (typeof key === "number" && banner.type === 1) {
              banner.textStyle[key].labelStyle = "";
              banner.textStyle[key].showLabelStyle = false;
            }
          } else {
            banner[dataKey][key] = value;
          }
        } else {
          Object.assign(banner, map);
        }
      });
    },
    // 增加bannerDataList的子元素
    addBannerSize (state, sizeInfo) {
      let {
        id,
        size,
        sizeName,
        type,
        textStyle,
        elementInfo,
        textInfo,
        textValue,
        logoFontSize,
        logoHeight,
        logoPositionX,
        logoPositionY,
        isLogo,
      } = sizeInfo;
      let bannerMap = JSON.parse(JSON.stringify(state.bannerData));
      bannerMap.sizeId = id;
      bannerMap.size = size;
      bannerMap.type = type;
      bannerMap.sizeName = sizeName;
      bannerMap.elementInfo = elementInfo;
      bannerMap.textInfo = textInfo;
      // 是否选使用角标
      const isShowLogo = state.bannerData.logoConfig.isLogo;
      bannerMap.logoConfig = {
        fontSize: logoFontSize,
        height: logoHeight,
        positionX: logoPositionX,
        positionY: logoPositionY,
        isLogo: isShowLogo && isLogo,
      };
      bannerMap.logoContent = isShowLogo && isLogo ? state.bannerData.logoContent : "";
      textValue && (bannerMap.textValue = textValue);
      bannerMap.isTextExceed = checkIsTextExceed(bannerMap.textValue, textStyle);
      for (let i = 0; i < bannerMap.textStyle.length; i++) {
        const style = JSON.parse(JSON.stringify(textStyle[i]));
        bannerMap.textStyle[i] = Object.assign(bannerMap.textStyle[i], style);
        // 特殊尺寸去掉标签样式
        if (type === 1) {
          bannerMap.textStyle[i].labelStyle = "";
          bannerMap.textStyle[i].showLabelStyle = false;
        }
      }
      state.bannerDataList.unshift(bannerMap);
      // sizeInfo.isSelect = true;
      sizeInfo.isTextExceed = bannerMap.isTextExceed;
    },
    // 增加bannerDataList的子元素
    addBannerDataList (state, bannerMap) {
      state.bannerDataList.push(bannerMap);
    },
    // 按照条件修改bannerDataList
    modifyBannerDataList (state, { condition, params }) {
      state.bannerDataList.forEach(item => {
        if (condition(item)) {
          Object.assign(item, params);
        }
      });
    },
    // 清空bannerDataList
    clearBannerDataList (state) {
      state.bannerDataList = [];
    },
    removeBannerSize (state, sizeInfo) {
      // sizeInfo.isSelect = false;
      sizeInfo.isTextExceed = false;
      const index = state.bannerDataList.findIndex(item => parseInt(item.sizeId) === sizeInfo.id);
      state.bannerDataList.splice(index, 1);
    },
    modifyTextValue (state, bannerMap) {
      if (!checkIsTextExceed(bannerMap.textValue, bannerMap.textStyle)) {
        bannerMap.isTextExceed = false;
      }
    },
    // 构造bannerDataList
    structBannerDataList (state, bannerDataList) {
      const {
        elementTypeId,
        textStyle,
        textInfo: { lineCount },
      } = bannerDataList.list[0];
      // 初始化banner列表数据
      bannerDataList.list.forEach(item => {
        item.isTextExceed = false;
        // 初始化标签样式参数
        item.textStyle.forEach(styleItem => {
          let arr = styleItem.textCountLimit.split("<x<");
          styleItem.max = arr[1];
          styleItem.min = arr[0];
          styleItem.showLabelStyle = styleItem.labelStyle.length > 0;
        });
      });
      state.bannerDataList = bannerDataList.list;
      state.bannerData = JSON.parse(JSON.stringify(bannerMap));
      // 如果存在角标，则选中角标，否则选中第一个
      const selectBannerData = bannerDataList.list.find(item => item.logoConfig.isLogo) || bannerDataList.list[0];
      Object.assign(state.bannerData, selectBannerData);
      state.bannerData.logoConfig.isLogo = state.bannerData.logoContent && state.bannerData.logoConfig.isLogo ? 1 : 0;
      // 如果角标未启用，则使用默认的角标配置
      if (!state.bannerData.logoConfig.isLogo) {
        state.bannerData.logoConfig = JSON.parse(JSON.stringify(bannerMap.logoConfig));
        state.bannerData.logoConfig.isLogo = 0;
        state.bannerData.logoContent = "";
      }
      Object.assign(state.bannerData, genInitSizeInfo(elementTypeId, lineCount));
      state.elementTypeId = elementTypeId;
      state.bannerData.textStyle.forEach((item, index) => {
        item.showLabelStyle = textStyle[index].labelStyle.length > 0;
        item.labelStyle = textStyle[index].labelStyle;
      });
    },
    clearCacheInfo (state) {
      state.bannerTextStyles = [];
      state.bannerBackgrounds = [];
      state.bannerElements = [];
      state.bannerData = JSON.parse(JSON.stringify(bannerMap));
      state.bannerDataList = [];
    },
  },
};
function checkIsTextExceed (texts, textStyles) {
  let res = false;
  for (let i = 0; i < textStyles.length; i++) {
    const st = textStyles[i];
    const len = texts[i].length;
    if (len < st.min || len > st.max) {
      return (res = true);
    }
  }
  return res;
}
